import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { palette, remCalc } from '../../css';

const Wrapper = styled.label`
    display: inline-flex;
    align-items: center;
    margin: ${remCalc(5, 0)};
`;

const Label = styled.span`
    padding-right: ${remCalc(10)};
`;

const Input = styled.input`
    position: absolute;
    opacity: 0;
    pointer-events: none;

    :checked + span::before {
        background: ${palette('orange', 'light')};
    }

    :checked + span::after {
        content: '✔';
        color: ${palette('white')};
        transform: translate(calc(${remCalc(40)} - 100%), -50%);
        background: ${palette('secondary', 'arteOrange')};
    }

    :focus + span {
        outline: ${palette('orange', 'base')} solid 1px;
        box-shadow: 0 0 8px ${palette('orange', 'light')};
    }

    :disabled + span {
        cursor: not-allowed;
        filter: grayscale(100%);
    }

    :disabled + span::after {
        box-shadow: none;
    }
`;

const Toggle = styled.span`
    cursor: pointer;
    position: relative;

    &:before,
    &:after {
        content: '';
        color: ${palette('grey', 'xxDark')};
        display: flex;
        align-items: center;
        justify-content: center;
        margin: ${remCalc(0, 3)};
        transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:before {
        height: ${remCalc(15)};
        width: ${remCalc(40)};
        border-radius: ${remCalc(15)};
        background: ${palette('grey', 'midDark')};
    }

    &:after {
        content: '✖';
        position: absolute;
        background-color: ${palette('white')};
        top: 50%;
        transform: translate(0, -50%);
        height: ${remCalc(25)};
        width: ${remCalc(25)};
        border-radius: 50%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.4);
    }
  }
`;

const Switch = ({ label, id, isChecked: _isChecked, onChange }) => {
    const [isChecked, setIsChecked] = React.useState(!!_isChecked);

    React.useEffect(() => {
        setIsChecked(!!_isChecked);
    }, [_isChecked]);

    const handleClick = () => {
        setIsChecked(!isChecked);
    };

    const handleChange = () => {
        onChange(isChecked);
    };

    return (
        <Wrapper onClick={handleClick} htmlFor={id}>
            {label && <Label>{label}</Label>}
            <Input defaultChecked={isChecked} onChange={handleChange} role="switch" type="checkbox" id={id} />
            <Toggle />
        </Wrapper>
    );
};
export const propTypes = {
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
};
Switch.propTypes = propTypes;
export const defaultProps = {
    className: '',
    isChecked: false,
    onChange: Function.prototype,
    label: '',
};
Switch.defaultProps = defaultProps;

export default Switch;
